<template>
    <page-module-builder
        class="dynamic-page-template"
        :components="templateComponents"
    />
</template>

<script>
    import PageModuleBuilder from '../../page-modules/PageModuleBuilder/PageModuleBuilder';

    export default {
        name: 'dynamic-page-template',

        components: { PageModuleBuilder },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Convert the attributes to components.
             *
             * @returns {Array}
             */
            templateComponents() {
                return Object.entries(this.attributes)
                    .filter(([key, val]) => (val && typeof val === 'object' && val.__typename) && key !== '__page')
                    .reduce((components, [, val]) => ([
                        ...components,
                        {
                            __page: this.attributes.__page,
                            ...val,
                        },
                    ]), []);
            },
        },
    };
</script>
